export default __webpack_public_path__ + "media/grid-systems.jpg";